'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';
import { useAppAuth } from '@/hooks/use-app-auth';

// Never advertise private entry based on local profile roles alone. Verify the current
// server session; identity changes invalidate the response and its rendered link.
export function LuminaTesterEntry() {
  const { session, loading } = useAppAuth();
  const uid = session?.uid;
  const eligible = session?.canAccessStudio;
  const [verifiedUid, setVerifiedUid] = useState<string | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    if (!loading && uid && eligible) {
      void fetch('/api/auth/session', { cache: 'no-store', signal: controller.signal })
        .then(async response => response.ok ? response.json() : null)
        .then(payload => {
          if (!controller.signal.aborted) setVerifiedUid(payload?.session?.uid === uid && payload.session.canAccessStudio ? uid : null);
        }).catch(() => { if (!controller.signal.aborted) setVerifiedUid(null); });
    }
    return () => controller.abort();
  }, [eligible, loading, uid]);
  if (loading || !eligible || !uid || verifiedUid !== uid) return null;
  return <p className="mt-8 text-sm"><Link href="/studio" prefetch={false} className="inline-block rounded px-3 py-3 underline underline-offset-4 focus-visible:outline">Private tester studio</Link></p>;
}
